"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clamp = exports.formatNumber = exports.safeToFloat = exports.safeToNumber = void 0;
function safeToNumber(n) {
    if (n == null || n === '')
        return NaN;
    if (typeof n === 'number')
        return n;
    return Math.trunc(parseInt(n, 10));
}
exports.safeToNumber = safeToNumber;
function safeToFloat(n) {
    if (n == null || n === '')
        return NaN;
    if (typeof n === 'number')
        return n;
    return parseFloat(n);
}
exports.safeToFloat = safeToFloat;
function formatNumber(value, { digits } = {}) {
    value = value.toString();
    let formattedValue = value;
    if (formattedValue.length === 0) {
        formattedValue = '0';
    }
    if (digits) {
        const digitLength = Number(digits);
        const isNegativeValue = value[0] === '-';
        // remove the dash so we can format the number
        if (isNegativeValue) {
            formattedValue = formattedValue.slice(1);
        }
        const lengthDiff = formattedValue.length - digitLength;
        if (lengthDiff < 0) {
            formattedValue = formattedValue.padStart(digitLength, '0');
        }
        else if (lengthDiff > 0) {
            formattedValue = formattedValue.slice(0, digitLength);
        }
        // prepend the dash again
        if (isNegativeValue) {
            formattedValue = `-${formattedValue}`;
        }
    }
    return formattedValue;
}
exports.formatNumber = formatNumber;
function clamp(n, min, max) {
    if (!Number.isNaN(max) && n > max)
        return max;
    if (!Number.isNaN(min) && n < min)
        return min;
    return n;
}
exports.clamp = clamp;
